import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-term-of-sale',
    imports: [TranslateModule],
    templateUrl: './term-of-sale.component.html'
})
export class TermOfSaleComponent {

    constructor(){

    }
}